import React, { useState, useRef } from "react";
import { IconInfoCircle, TextIconButton, MobileSheet, ButtonIconPosition } from "@geotab/zenith";

interface InfoModalProps {
    title: string;
    content: React.ReactNode;
}

// Expects strings to be already translated
export const InfoModal: React.FC<InfoModalProps> = ({ title, content }) => {
    const triggerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="driver-safety__infoModal">
            <TextIconButton icon={IconInfoCircle} iconSize="huge" iconPosition={ButtonIconPosition.Start} type="tertiary" onClick={() => setIsOpen(true)} ref={triggerRef} />
            <MobileSheet label="infoModal" wrapperClassName="driver-safety__infoModal-wrapper" triggerRef={triggerRef} isOpen={isOpen} onHidePanel={() => setIsOpen(false)} onCloseClick={() => setIsOpen(false)}>
                <MobileSheet.Title>{title}</MobileSheet.Title>
                <MobileSheet.Content className="driver-safety__infoModal_content">{content}</MobileSheet.Content>
            </MobileSheet>
        </div>
    );
};
